import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  /** Signal backing store for template change detection */
  apiLoaderSignal = signal(false);

  get apiLoader(): boolean {
    return this.apiLoaderSignal();
  }

  set apiLoader(value: boolean) {
    this.apiLoaderSignal.set(value);
  }

  public printApiLoader: boolean = false;



  constructor() { }
}
